"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9965],{

/***/ 56148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_utils_icloudLoginResult__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83469);


/**
 * iCloud 登录返回「密码不对」时，让用户退回「输入账号密码」那一步重填。
 *
 * 规则本身在 src/utils/icloudLoginResult.js（纯函数，可单测）；这里只负责把它接到组件状态上。
 *
 * ⚠️ 仅适用于 iOS / iCloud 登录流程。Android 走 android-auth，不会返回 10003，
 *    所以 android/ 下的弹窗（android/login、android/settings-bind-device、SyncProgress/android-cloud）不要接这个 hook。
 *
 * 两种情况不重复处理（2026-09-23 与用户确认）：
 * 1. 已经停在「输入账号密码」那一步（current === 0）；
 * 2. 被锁 / 重新验证弹窗正在显示（用户已经在那套弹窗里输密码，再退回会叠两层界面）。
 *
 * @returns {(ec: number) => boolean} true = 本次已退回「输入账号密码」那一步
 */ const useIcloudCredentialReverify = (param)=>{
    let { current , setCurrent , lockedFlowOpen =false  } = param;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((ec)=>{
        const { type  } = (0,src_utils_icloudLoginResult__WEBPACK_IMPORTED_MODULE_1__/* .resolveIcloudLogin */ .O)({
            ec
        }, {
            step: current,
            lockedFlowOpen
        });
        if (type !== "reenterPassword") return false;
        setCurrent(0);
        return true;
    }, [
        current,
        lockedFlowOpen,
        setCurrent
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useIcloudCredentialReverify);


/***/ }),

/***/ 82000:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ icloud_locked_useIcloudLockedFlow; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/i18n.js + 1 modules
var i18n = __webpack_require__(61906);
// EXTERNAL MODULE: ./src/@api/login.js + 1 modules
var login = __webpack_require__(53399);
// EXTERNAL MODULE: ./src/utils/updateDeviceCredentials.js
var updateDeviceCredentials = __webpack_require__(80122);
;// CONCATENATED MODULE: ./src/utils/supportChat.js
const openSupportChat = function() {
    let { maxRetries =60 , intervalMs =500  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return new Promise((resolve)=>{
        if (false) {}
        let attempts = 0;
        const tryOpen = ()=>{
            var ref;
            attempts += 1;
            const openWhenReady = (ref = window.ChatPlugin) === null || ref === void 0 ? void 0 : ref.openWhenReady;
            if (typeof openWhenReady === "function") {
                try {
                    Promise.resolve(openWhenReady.call(window.ChatPlugin, true)).then((result)=>resolve(result !== false)).catch(()=>resolve(false));
                    return;
                } catch (e) {}
            }
            if (attempts >= maxRetries) {
                resolve(false);
                return;
            }
            setTimeout(tryOpen, intervalMs);
        };
        tryOpen();
    });
};

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/ios-extreme/icloud-locked/AppleIdLockedModal.js





const UNLOCK_URL = "https://iforgot.apple.com/unlock";
const AppleIdLockedModal = (param)=>{
    let { open , onClose , onReverify , onContactUs  } = param;
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    const [mounted, setMounted] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setMounted(true);
    }, []);
    if (!open || !mounted) return null;
    return /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed bottom-0 left-0 right-0 top-[60px] z-[1315] flex items-center justify-center overflow-y-auto bg-[rgba(0,0,0,0.5)] px-4 py-4 smj:items-start smj:px-4 smj:pb-4 smj:pt-3 smjs:left-[300px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative my-auto flex w-full max-w-[544px] flex-col overflow-hidden rounded-[12px] bg-white shadow-[0px_6px_20px_0px_rgba(23,24,33,0.2)] smj:my-0 smj:max-h-[calc(100dvh-60px-28px)] lg:rounded-[16px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    "aria-label": "close",
                    className: "absolute right-3 top-3 z-[2] flex h-6 w-6 items-center justify-center text-[#9297AF]",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "relative block h-4 w-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute left-1/2 top-1/2 block h-[18px] w-[2px] -translate-x-1/2 -translate-y-1/2 rotate-45 rounded bg-current"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute left-1/2 top-1/2 block h-[18px] w-[2px] -translate-x-1/2 -translate-y-1/2 -rotate-45 rounded bg-current"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "min-h-0 flex-1 overflow-y-auto px-4 py-6 lg:p-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center gap-3 lg:gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/images/ios-locked/lock-icon.svg",
                                    alt: "",
                                    width: 48,
                                    height: 48,
                                    className: "h-12 w-12"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-[20px] font-semibold leading-[28px] text-[#020417] lg:text-[24px] lg:leading-[36px]",
                                            children: t("Apple ID locked")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "mt-2.5 text-[16px] leading-6 text-[#020417]/80",
                                            children: t("Your Apple ID was locked due to multiple failed password attempts Follow these steps to unlock it")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-4 flex flex-col gap-6 rounded-[16px] bg-[#F5FAFF] p-3 lg:mt-8 lg:gap-6 lg:p-4",
                            children: [
                                {
                                    step: "1",
                                    content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            t("Apple locked step 1 prefix"),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: UNLOCK_URL,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "break-all text-[#2405F2] underline",
                                                children: UNLOCK_URL
                                            }),
                                            t("Apple locked step 1 suffix")
                                        ]
                                    })
                                },
                                {
                                    step: "2",
                                    content: t("Apple locked step 2")
                                },
                                {
                                    step: "3",
                                    content: t("Apple locked step 3")
                                }
                            ].map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-start gap-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full bg-[#6586FF] text-[15px] leading-[22px] text-white",
                                            children: item.step
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "min-w-0 flex-1 break-words text-[15px] leading-[22px] text-[#353746]",
                                            children: item.content
                                        })
                                    ]
                                }, item.step))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-8 flex flex-col items-center gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "w-full rounded-[40px] bg-[#FFCF55] px-10 py-2.5 text-[14px] font-medium leading-5 text-[#020417] lg:w-[240px]",
                                    onClick: ()=>window.open(UNLOCK_URL, "_blank", "noopener,noreferrer"),
                                    children: t("Unlock on Apple")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "w-full rounded-[40px] border border-[#454CFF] px-10 py-2.5 text-[14px] font-medium leading-5 text-[#454CFF] lg:w-[240px]",
                                    onClick: onReverify,
                                    children: t("Unlocked, Reverify")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "text-[14px] font-medium leading-5 text-[#1C1E53]/60",
                                    onClick: onContactUs,
                                    children: t("Contact Us")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }), document.body);
};
/* harmony default export */ var icloud_locked_AppleIdLockedModal = (AppleIdLockedModal);

// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 14 modules
var input = __webpack_require__(96456);
;// CONCATENATED MODULE: ./src/components/ios-extreme/icloud-locked/ExtremeReverifyModal.js






const ExtremeReverifyModal = (param)=>{
    let { open , loading , mode =1 , username , password , errorText , lockedErrorText , onPasswordChange , onClose , onSendCode , onLater  } = param;
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    const [mounted, setMounted] = (0,react.useState)(false);
    const [showPassword, setShowPassword] = (0,react.useState)(false);
    const titleKey = mode === 2 ? "Extreme Data Verification" : "iCloud Account Verification";
    (0,react.useEffect)(()=>{
        setMounted(true);
    }, []);
    (0,react.useEffect)(()=>{
        if (!open) {
            setShowPassword(false);
        }
    }, [
        open
    ]);
    if (!open || !mounted) return null;
    const passwordHasError = Boolean(errorText || lockedErrorText);
    return /*#__PURE__*/ (0,react_dom.createPortal)(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed bottom-0 left-0 right-0 top-[60px] z-[1316] flex items-center justify-center overflow-y-auto bg-[rgba(0,0,0,0.5)] px-4 py-4 smj:items-start smj:px-4 smj:pb-4 smj:pt-3 smjs:left-[300px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative my-auto flex w-full max-w-[544px] flex-col overflow-hidden rounded-[12px] bg-white shadow-[0px_6px_20px_0px_rgba(23,24,33,0.2)] smj:my-0 smj:max-h-[calc(100dvh-60px-28px)] lg:rounded-[16px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    "aria-label": "close",
                    className: "absolute right-3 top-3 z-[2] flex h-6 w-6 items-center justify-center text-[#9297AF]",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "relative block h-4 w-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute left-1/2 top-1/2 block h-[18px] w-[2px] -translate-x-1/2 -translate-y-1/2 rotate-45 rounded bg-current"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "absolute left-1/2 top-1/2 block h-[18px] w-[2px] -translate-x-1/2 -translate-y-1/2 -rotate-45 rounded bg-current"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "min-h-0 flex-1 overflow-y-auto p-6 lg:p-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center gap-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/images/apps/apple.svg",
                                    alt: "",
                                    width: 60,
                                    height: 69,
                                    className: "h-[60px] w-[52px]"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-center text-[20px] font-semibold leading-[28px] text-[#020417] lg:text-[24px] lg:leading-9",
                                    children: t(titleKey)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-6 flex flex-col gap-2.5",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-2.5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: "text-[16px] font-medium leading-6 text-[#020417]",
                                            children: t("Apple ID")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex items-center justify-between rounded-[8px] border border-[#E9EFF3] bg-[rgba(244,245,246,0.92)] px-4 py-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                                bordered: false,
                                                className: "!p-0 text-[16px] leading-6 text-[#020417]",
                                                value: username,
                                                disabled: true,
                                                placeholder: t("Apple ID")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col gap-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: "text-[16px] font-medium leading-6 text-[#020417]",
                                            children: t("Password")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex h-10 items-center justify-between rounded-[8px] border px-4 py-2 ".concat(passwordHasError ? "border-[#FF4C4C]" : "border-[#E9EFF3]"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                                    bordered: false,
                                                    type: showPassword ? "text" : "password",
                                                    className: "!p-0 text-[16px] leading-6 text-[#020417] placeholder:text-[#BBBFca]",
                                                    value: password,
                                                    onChange: (e)=>{
                                                        return onPasswordChange === null || onPasswordChange === void 0 ? void 0 : onPasswordChange(e.target.value);
                                                    },
                                                    placeholder: t("Password")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    className: "ml-2 shrink-0",
                                                    onClick: ()=>setShowPassword((prev)=>!prev),
                                                    "aria-label": "toggle password",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: showPassword ? "/extreme/open.svg" : "/extreme/close.svg",
                                                        alt: "",
                                                        width: 24,
                                                        height: 24,
                                                        className: "h-6 w-6"
                                                    })
                                                })
                                            ]
                                        }),
                                        passwordHasError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-right text-[12px] leading-normal text-[#FF4C4C]",
                                            children: lockedErrorText || errorText
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-6 flex items-start gap-2.5 rounded-[12px] bg-[rgba(74,119,254,0.1)] p-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/images/ios-locked/info-icon.svg",
                                    alt: "",
                                    width: 24,
                                    height: 24,
                                    className: "mt-0.5 h-6 w-6 shrink-0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[14px] leading-5 text-[#4A77FE]",
                                    children: t("Once verified Apple will send a two-factor verification code or SMS to the monitored device Please ensure the device can receive messages")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-8 flex flex-col items-center gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    disabled: loading,
                                    className: "w-full rounded-[40px] bg-[#FFCF55] px-10 py-2.5 text-[14px] font-medium leading-5 text-[#020417] lg:w-[240px] ".concat(loading ? "opacity-70" : ""),
                                    onClick: onSendCode,
                                    children: t("Send Code")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "text-[14px] font-medium leading-5 text-[#1C1E53]/60",
                                    onClick: onLater,
                                    children: t("Later for Verification")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }), document.body);
};
/* harmony default export */ var icloud_locked_ExtremeReverifyModal = (ExtremeReverifyModal);

;// CONCATENATED MODULE: ./src/components/ios-extreme/icloud-locked/useIcloudLockedFlow.js








const getDefaultCountry = ()=>{
    try {
        var ref, ref1;
        return (((ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.country_name) || "").toLocaleLowerCase();
    } catch (e) {
        return "";
    }
};
const useIcloudLockedFlow = (param)=>{
    let { mode =1 , updateCredentialsOnLock =true , getCountry =getDefaultCountry , onTwoStepRequired , onDirectSuccess  } = param;
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    const [lockedOpen, setLockedOpen] = (0,react.useState)(false);
    const [reverifyOpen, setReverifyOpen] = (0,react.useState)(false);
    const [reverifyLoading, setReverifyLoading] = (0,react.useState)(false);
    const [reverifyForm, setReverifyForm] = (0,react.useState)({
        username: "",
        password: ""
    });
    const [reverifyError, setReverifyError] = (0,react.useState)("");
    const [reverifyLockedError, setReverifyLockedError] = (0,react.useState)("");
    const handleEc10005 = (0,react.useCallback)(async (param)=>{
        let { username , password  } = param;
        if (updateCredentialsOnLock) {
            try {
                await (0,updateDeviceCredentials/* default */.Z)({
                    username,
                    password,
                    verify: 5
                });
            } catch (error) {
                ;
            }
        }
        setReverifyForm({
            username: username || "",
            password: ""
        });
        setReverifyError("");
        setReverifyLockedError("");
        setLockedOpen(true);
    }, [
        updateCredentialsOnLock
    ]);
    const openReverify = (0,react.useCallback)(()=>{
        setLockedOpen(false);
        setReverifyError("");
        setReverifyLockedError("");
        setReverifyOpen(true);
    }, []);
    const closeReverify = (0,react.useCallback)(()=>{
        setReverifyOpen(false);
        setReverifyError("");
        setReverifyLockedError("");
    }, []);
    const handleContactUs = (0,react.useCallback)(()=>{
        openSupportChat();
    }, []);
    const handleReverifySendCode = (0,react.useCallback)(async ()=>{
        const { username , password  } = reverifyForm;
        if (!username || !password) {
            setReverifyError(t("Value cannot be empty"));
            setReverifyLockedError("");
            return;
        }
        setReverifyLoading(true);
        setReverifyError("");
        setReverifyLockedError("");
        try {
            const { data  } = await (0,login.iosLoginVerification)({
                mode,
                username,
                password,
                country: getCountry()
            });
            if ((data === null || data === void 0 ? void 0 : data.ec) === 10005) {
                setReverifyLockedError(data.em || t("Apple ID locked"));
                setReverifyLoading(false);
                return;
            }
            if ((data === null || data === void 0 ? void 0 : data.ec) === 10004) {
                setReverifyOpen(false);
                setReverifyLoading(false);
                await (onTwoStepRequired === null || onTwoStepRequired === void 0 ? void 0 : onTwoStepRequired({
                    data,
                    username,
                    password
                }));
                return;
            }
            if ((data === null || data === void 0 ? void 0 : data.ec) === 10000 || (data === null || data === void 0 ? void 0 : data.ec) === 0) {
                setReverifyOpen(false);
                setReverifyLoading(false);
                await (onDirectSuccess === null || onDirectSuccess === void 0 ? void 0 : onDirectSuccess({
                    data,
                    username,
                    password
                }));
                return;
            }
            if ((data === null || data === void 0 ? void 0 : data.ec) === 10003) {
                setReverifyError(data.em);
                setReverifyLoading(false);
                return;
            }
            setReverifyError((data === null || data === void 0 ? void 0 : data.em) || t("Incorrect username or password"));
            setReverifyLoading(false);
        } catch (error) {
            ;
            setReverifyError(t("Network error, please try again"));
            setReverifyLoading(false);
        }
    }, [
        getCountry,
        mode,
        onDirectSuccess,
        onTwoStepRequired,
        reverifyForm,
        t
    ]);
    const lockedFlowModals = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icloud_locked_AppleIdLockedModal, {
                open: lockedOpen,
                onClose: ()=>setLockedOpen(false),
                onReverify: openReverify,
                onContactUs: handleContactUs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icloud_locked_ExtremeReverifyModal, {
                open: reverifyOpen,
                loading: reverifyLoading,
                mode: mode,
                username: reverifyForm.username,
                password: reverifyForm.password,
                errorText: reverifyError,
                lockedErrorText: reverifyLockedError,
                onPasswordChange: (value)=>{
                    setReverifyForm((prev)=>({
                            ...prev,
                            password: value
                        }));
                    setReverifyError("");
                    setReverifyLockedError("");
                },
                onClose: closeReverify,
                onSendCode: handleReverifySendCode,
                onLater: closeReverify
            })
        ]
    });
    return {
        handleEc10005,
        lockedFlowModals,
        // 被锁 / 重新验证弹窗是否正在显示：调用方据此避免再叠一层「输入账号密码」
        lockedFlowOpen: lockedOpen || reverifyOpen,
        closeLockedModal: ()=>setLockedOpen(false),
        closeReverifyModal: closeReverify
    };
};
/* harmony default export */ var icloud_locked_useIcloudLockedFlow = (useIcloudLockedFlow);


/***/ }),

/***/ 83469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ resolveIcloudLogin; },
/* harmony export */   "UR": function() { return /* binding */ isIcloudOk; },
/* harmony export */   "VO": function() { return /* binding */ ICLOUD_EC; },
/* harmony export */   "Y8": function() { return /* binding */ isIcloudSendOk; }
/* harmony export */ });
/* unused harmony export ICLOUD_OK */
/**
 * iCloud 登录接口（iosLoginVerification）返回码的统一口径。
 *
 * 这套码原本硬编码在 12 个弹窗里（10003 / 10004 / 10005 …），改规则要翻十几个文件。
 * 这里集中定义一次；组件只 import 常量 + resolveIcloudLogin，不再出现魔法数字。
 *
 * ⚠️ 仅适用于 iOS / iCloud 登录流程。Android 走 android-auth，不会返回这些码。
 */ /** 成功码：0 与 10000 都算成功 */ const ICLOUD_OK = [
    0,
    10000
];
const ICLOUD_EC = {
    PASSWORD: 10003,
    TWO_STEP: 10004,
    LOCKED: 10005,
    TERMS: 10031 // 需要先同意条款
};
/** 是否成功。传整个 data 或直接传 ec 都行 */ const isIcloudOk = (input)=>{
    const ec = input && typeof input === "object" ? input.ec : input;
    return ICLOUD_OK.includes(ec);
};
/** 发验证码场景的「算成功」：成功码，或需要二步验证（说明码已发出） */ const isIcloudSendOk = (ec)=>isIcloudOk(ec) || ec === ICLOUD_EC.TWO_STEP;
/**
 * 一次 iCloud 登录返回该怎么处理。纯函数，不依赖 React，可直接单测。
 *
 * @param {object} data 接口返回体（读 data.ec / data.em）
 * @param {object} [ctx]
 * @param {number}  [ctx.step=0]           组件当前步骤：0 = 输入账号密码，1 = 填验证码
 * @param {boolean} [ctx.lockedFlowOpen]   被锁 / 重新验证弹窗是否正在显示
 * @returns {{ type: 'ok'|'twoStep'|'locked'|'terms'|'reenterPassword'|'toast', ec: number, message: string }}
 */ const resolveIcloudLogin = function(data) {
    let { step =0 , lockedFlowOpen =false  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const ec = data === null || data === void 0 ? void 0 : data.ec;
    const message = (data === null || data === void 0 ? void 0 : data.em) || "";
    if (isIcloudOk(ec)) return {
        type: "ok",
        ec,
        message
    };
    if (ec === ICLOUD_EC.TWO_STEP) return {
        type: "twoStep",
        ec,
        message
    };
    if (ec === ICLOUD_EC.LOCKED) return {
        type: "locked",
        ec,
        message
    };
    if (ec === ICLOUD_EC.TERMS) return {
        type: "terms",
        ec,
        message
    };
    // 密码不对 → 退回「输入账号密码」重填。
    // 例外：已经停在输密码那一步、或被锁 / 重新验证弹窗正开着 → 只提示，不退回
    if (ec === ICLOUD_EC.PASSWORD && step !== 0 && !lockedFlowOpen) {
        return {
            type: "reenterPassword",
            ec,
            message
        };
    }
    return {
        type: "toast",
        ec,
        message
    };
};


/***/ }),

/***/ 80122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ isUpdateCredentialsOk; }
/* harmony export */ });
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53399);

const readDeviceUser = ()=>{
    if (false) {}
    try {
        return JSON.parse(localStorage.getItem("DeviceUser") || "null") || {};
    } catch (e) {
        return {};
    }
};
const isUpdateCredentialsOk = (result)=>{
    if (!result) return false;
    if (result.code == 500 && result.msg == "Expired") return false;
    if (result.code != null && Number(result.code) !== 0) return false;
    return true;
};
/**
 * 已有设备更新 iCloud 凭据 / 锁定状态。
 * POST /api/v2/device/device-info-update
 * Body: { username, password, verify }  — verify=1 成功，verify=5 锁定
 * 不走绑定接口、不传 order_id。
 */ const updateDeviceCredentials = async function() {
    let { username , password , verify  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const deviceUser = readDeviceUser();
    let result;
    try {
        result = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.updateDeviceInfo)({
            username,
            password,
            verify
        });
    } catch (e) {
        return {
            code: -1,
            msg: (e === null || e === void 0 ? void 0 : e.message) || "Network error"
        };
    }
    if (isUpdateCredentialsOk(result)) {
        localStorage.setItem("DeviceUser", JSON.stringify({
            ...deviceUser,
            username,
            password
        }));
    }
    return result;
};
/* harmony default export */ __webpack_exports__["Z"] = (updateDeviceCredentials);


/***/ })

}]);